import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LOGO } from "@/lib/brand";
import { api } from "@/lib/api";
import { Instagram, Facebook, Mail, MapPin, Phone } from "lucide-react";

export const ADDRESS = "The Berkeley Cultural Center, 23 Berkeley Road, Second Floor, Pembroke, Bermuda";
export const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(ADDRESS);

export function Footer() {
  const [live, setLive] = useState(false);
  const [phone, setPhone] = useState("441-519-1794");
  useEffect(() => { api.get("/public/settings").then((r) => { setLive(!!r.data.registration_live); if (r.data.contact_phone) setPhone(r.data.contact_phone); }).catch(() => {}); }, []);
  const telHref = "tel:+1" + phone.replace(/[^0-9]/g, "");
  return (
    <footer className="relative bg-abyss text-white pt-16 pb-8 overflow-hidden grain" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src={LOGO} alt="Adventure Rock Bermuda" className="h-14 w-14 object-contain" />
            <div>
              <p className="font-display font-extrabold text-lg">ADVENTURE ROCK BERMUDA</p>
              <p className="text-turquoise text-sm font-semibold tracking-wide">BERMUDA'S PLAY CAFÉ · OPEN DAILY 9 AM – 6 PM</p>
            </div>
          </div>
          <p className="text-white/60 mt-4 max-w-md text-sm leading-relaxed">
            A mysterious island world of learning, discovery and friendship for Bermuda's young explorers.
          </p>
          <div className="flex flex-wrap gap-3 mt-5">
            <a href={MAPS_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-turquoise/15 hover:bg-turquoise hover:text-navy text-turquoise font-semibold rounded-full px-4 py-2 text-sm transition-colors" data-testid="footer-directions-btn"><MapPin className="w-4 h-4" /> Get Directions</a>
            <a href="mailto:adventurerockbermuda@gmail.com" className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-full px-4 py-2 text-sm transition-colors" data-testid="footer-email-btn"><Mail className="w-4 h-4" /> Email Us</a>
            <a href={telHref} className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-full px-4 py-2 text-sm transition-colors" data-testid="footer-call-btn"><Phone className="w-4 h-4" /> Call {phone}</a>
          </div>
          <p className="text-white/40 text-xs mt-3 flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> {ADDRESS}</p>
        </div>

        <div>
          <p className="font-display font-bold text-gold mb-3 text-sm tracking-wider uppercase">Explore</p>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to={live ? "/register" : "/join"} className="hover:text-turquoise">{live ? "Registration" : "Join Mailing List"}</Link></li>
            <li><Link to="/about" className="hover:text-turquoise" data-testid="footer-about-link">About Adventure Rock</Link></li>
            <li><Link to="/login" className="hover:text-turquoise">Parent Login</Link></li>
            <li><Link to="/calendar" className="hover:text-turquoise">Term Calendar</Link></li>
            <li><Link to="/faq" className="hover:text-turquoise">FAQ</Link></li>
          </ul>
        </div>

        <div>
          <p className="font-display font-bold text-gold mb-3 text-sm tracking-wider uppercase">Info</p>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/faq" className="hover:text-turquoise">Policies</Link></li>
            <li><Link to="/faq" className="hover:text-turquoise">Privacy</Link></li>
            <li><Link to="/faq" className="hover:text-turquoise">Terms</Link></li>
            <li><a href="mailto:adventurerockbermuda@gmail.com" className="flex items-center gap-1 hover:text-turquoise"><Mail className="w-4 h-4" /> adventurerockbermuda@gmail.com</a></li>
            <li><a href={telHref} className="flex items-center gap-1 hover:text-turquoise" data-testid="footer-phone-link"><Phone className="w-4 h-4" /> {phone}</a></li>
          </ul>
          <div className="flex gap-3 mt-4">
            <a href="#" className="text-white/60 hover:text-pink" aria-label="Instagram"><Instagram className="w-5 h-5" /></a>
            <a href="#" className="text-white/60 hover:text-turquoise" aria-label="Facebook"><Facebook className="w-5 h-5" /></a>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 mt-12 pt-6 border-t border-white/10 text-center text-white/40 text-xs">
        © 2026 Adventure Rock Bermuda. The Rock is Calling.
      </div>
    </footer>
  );
}
